import type { BaseProductDetails } from '../../../../types/CoreShoppingExperience';

const isProductEquals = (a: BaseProductDetails, b: Partial<BaseProductDetails>) =>
  // note: consider Rail
  a.departureDateTime === b.departureDateTime &&
  a.originCode === b.originCode &&
  a.destinationCode === b.destinationCode;
export default isProductEquals;
